import { CSSProperties, useMemo } from 'react';

import { TBlock } from '@wp-block-builder/package';
import { useEvalLiquid } from '@wp-block-builder/stores/WaypointRendererStore';

import cleanupCssStyle from './helpers/cleanupCssStyle';

export function useEvaluatedHiddenCondition(block: TBlock): boolean {
  const evalValue = useEvalLiquid();
  const hiddenConditionTemplate = block.sectionProps?.hiddenCondition || null;
  return useMemo(() => {
    if (typeof hiddenConditionTemplate !== 'string') {
      return false;
    }
    return Boolean(evalValue(hiddenConditionTemplate));
  }, [hiddenConditionTemplate, evalValue]);
}

export function useSectionStyle(block: TBlock): CSSProperties {
  return useMemo(() => ({ ...cleanupCssStyle(block.style || {}), maxWidth: '100%', boxSizing: 'border-box' }), [block]);
}

export function useEditableSectionStyle(block: TBlock): CSSProperties {
  const hidden = useEvaluatedHiddenCondition(block);
  const baseStyle = useSectionStyle(block);
  return useMemo(() => (hidden ? { ...baseStyle, opacity: 0.4 } : baseStyle), [baseStyle, hidden]);
}
